import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ButtonRedirectStyle = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 180px;
  height: 40px;
  border: none;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.normal;
  }};
  box-shadow: ${({ theme }) => {
    return theme.shadow;
  }};
  background-color: ${({ theme }) => {
    return theme.colors.blue;
  }};
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  color: ${({ theme }) => {
    return theme.colors.white;
  }};
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.normal;
  }};
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => {
      return theme.colors.darkBlue;
    }};
  }
  &:disabled {
    background-color: #888;
  }
`;
